<template>
  <div class="card-header border-0 pt-5">
    <div class="card-title">
      <div class="card-label">
        <div class="font-weight-bolder">
          <div class="text-uppercase">
            {{ $t("Total Family Count") }}
          </div>
        </div>
        <span
            class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t("This information is based on Count") }}</span>
      </div>
    </div>
    <div class="card-toolbar">
          <span class="label pulse pulse-success">
          <span class="position-relative">{{ adultFinalCount }}A</span>
          <span class="pulse-ring"></span>
      </span>
      +
      <span class="label pulse pulse-success">
                      <span class="position-relative">{{ childrenFinalCount }}C</span>
                      <span class="pulse-ring"></span>
                  </span>
      =
      <span class="symbol symbol-light-success symbol-50">
                            <span class="symbol-label font-weight-bolder font-size-h6">
                                {{ finalCount }}
                            </span>
                        </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'family-count',
  props: {
    api_data: Object
  },
  data: function () {
    return {
      finalCount: 0,
      adultFinalCount: 0,
      childrenFinalCount: 0,
    };
  },
  watch: {
    $props: {
      handler() {
        this.finalCount = 0;
        this.adultFinalCount = 0;
        this.childrenFinalCount = 0;
        this.adultFinalCount += this.floatOrZero(this.api_data.Farmer.family_male)
        this.adultFinalCount += this.floatOrZero(this.api_data.Farmer.family_female)
        this.childrenFinalCount += this.floatOrZero(this.api_data.Farmer.family_boy)
        this.childrenFinalCount += this.floatOrZero(this.api_data.Farmer.family_girl)
        this.finalCount = this.adultFinalCount + this.childrenFinalCount;
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    floatOrZero(integer) {
      return parseInt(integer) || 0;
    }
  }
}
</script>
